import { Component, OnInit, HostListener, TemplateRef } from '@angular/core';
import { momDashboard_MyMeetings, momDashboard } from '../models/MOMForm';
import Notiflix from "notiflix";
import { UserService } from '../services/user.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { MasterMOMService } from '../services/master-mom.service';
import { ToastrUtilsService } from '../services/toastr-utils.service';
import { UtilityService } from '../services/utility.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { formatDate } from '@angular/common';
import { AdminService } from '../services/admin.service';
import { pairText } from '../models/users';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  providers: [ToastrUtilsService]
})
export class SearchComponent implements OnInit {
  public lstMOMDashboard_MyMeetings: momDashboard_MyMeetings[] = [];
  searchText: string;
  login_UserID: any;
  checkBoxVal: number = 1;
  isTBT = false;
  disableMore: boolean;
  PostStartIndex: number = 1;
  PostMaxCount: number = 10;
  startDate: Date;
  endDate: Date;
  model: any = {};
  ifcountgreaterthanzero: boolean;
  noDataImage: string;
  modalMeeting: BsModalRef;
  modalSearch: BsModalRef;
  mid: any;
  pagetype = "MEETING";
  public ngbModalOptions: any = {
    backdrop: 'static',
    keyboard: false
  };
  searchAdd: string;
    isLoader: boolean;
    data: any=[];
    strK1: string;
    strI1: string;
  constructor(public utilityService: UtilityService,
    private toastr: ToastrUtilsService,
    public momMasterservice: MasterMOMService,
    private modalService: BsModalService,
    private userService: UserService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    public restApi: AdminService) { }
  @HostListener("window:scroll", [])
  onScroll(): void {
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.disableMore) {
        this.disableMore = true;

        this.getMoreSearch();
      }

    }
  }
  ngOnInit(): void {
    this.loadpairText();
    this.noDataImage = this.utilityService.getnodataImage();
    var user = this.userService.getUserInfo();
    if(user==undefined){
      this.userService.logout();
    }
    else{
    this.login_UserID = user.id;
    }

    this.isTBT = user.isTBT == 'false' ? false : true;
    let that = this;
    setTimeout(function () {
    
      that._activatedRoute.queryParams.subscribe((params: Params) => {
      let QText = params['QText'];
        that.searchText = (QText != null && QText != '') ? atob(QText) : '';

        that.getSearchList(true);
        that.ifcountgreaterthanzero = false;
        that.PostMaxCount = 10;
    });
    }, 100);

    this.data = [];
  }
  loadpairText() {
    ;
    let inpValue = new pairText();
    inpValue.k1 = '';
    this.restApi.callpairText(inpValue)
      .subscribe(data => {
        ;
        let rtnData: pairText;
        rtnData = data;
        this.strK1 = rtnData.k1;
        this.strI1 = rtnData.i1;
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getMoreSearch() {
    this.getSearchList(false);
  }

  onSearch() {
    if (this.model.startDate != '' && this.model.startDate != null && this.model.startDate != undefined) {
      if (this.model.endDate == '' || this.model.endDate == null || this.model.endDate == undefined) {
        this.toastr.ErrorCustomMessage('End date is required');
        return;
      }
    }
    if (this.model.endDate != '' && this.model.endDate != null && this.model.endDate != undefined) {
      if (this.model.startDate == '' || this.model.startDate == null || this.model.startDate == undefined) {
        this.toastr.ErrorCustomMessage('Start date is required');
        return;
      }
    }
    this.getSearchList(true);
  }

  getSearchList(isStart: boolean) {
    ;
    Notiflix.Block.Dots('div#pageloadcontainer');
    let inpValue = new momDashboard();

    inpValue.userUno = this.login_UserID;
    inpValue.actionType = this.checkBoxVal == 2 ? 'ATTENDANCE' : this.checkBoxVal == 3 ? 'TBD' : 'MEETING';
    inpValue.searchText = this.searchText;
    this.PostStartIndex = (this.PostStartIndex == undefined || this.PostStartIndex < 1 || isStart) ? 1 : this.PostStartIndex;
    inpValue.startIndex = this.PostStartIndex;
    inpValue.maxCount = this.PostMaxCount;
    inpValue.startdt = (this.model.startDate != null && this.model.startDate != undefined) ? formatDate(this.model.startDate , 'yyyy-MM-dd', 'en-US'): '9999-01-01';
    inpValue.enddt = (this.model.endDate != null && this.model.endDate != undefined) ? formatDate(this.model.endDate, 'yyyy-MM-dd', 'en-US'): '9999-01-01';
    this.momMasterservice.getSearchList(inpValue)
      .subscribe((data: any) => {
        if (this.PostStartIndex == 1) {
          this.lstMOMDashboard_MyMeetings = [];
        }
        let dataItemList: any = [];
        dataItemList = data.lstMOMDashboard_MyMeetings;
        for (var i = 0; i < dataItemList.length; i++) {
          let inputData = new momDashboard_MyMeetings();
          inputData.meetingDate = dataItemList[i].meetingDate;
          inputData.approvalStatus = dataItemList[i].approvalStatus;
          inputData.startTime = dataItemList[i].startTime;
          inputData.endTime = dataItemList[i].endTime;
          inputData.meetingName = dataItemList[i].meetingName;
          inputData.subjectAtd = dataItemList[i].subjectAtd;
          inputData.meetingRoom = dataItemList[i].meetingRoom;
          inputData.genInfoAtdUno = dataItemList[i].genInfoAtdUno;
          this.lstMOMDashboard_MyMeetings.push(inputData);
        }
        //this.lstMOMDashboard_MyMeetings = data.lstMOMDashboard_MyMeetings;
        console.log('search', data);
        this.disableMore = (dataItemList.length >= 10) ? false : true;
        if (dataItemList.length > 0) {
          this.ifcountgreaterthanzero = true;
          this.PostStartIndex = this.PostStartIndex + 1;
        }

        Notiflix.Block.Remove('div#pageloadcontainer', 500);
      },
        (error) => {
          Notiflix.Block.Remove('div#pageloadcontainer', 500);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        Notiflix.Block.Remove('div#pageloadcontainer', 500);
      });

  }
  TypeCheckBoxSelection(val) {
    ;
    this.checkBoxVal = val;
    this.pagetype = this.checkBoxVal == 2 ? 'ATTENDANCE': 'MEETING';
    this.getSearchList(true);
  }

  openModalnewMeeting(template1: TemplateRef<any>, item) {
    ;
    this.mid = item;
    this.modalMeeting = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-xl modal-full modal-dialog-scrollable modal-body-scrollable' }, this.ngbModalOptions
      )
    );
  }
  openModalSearchAdd(template1: TemplateRef<any>) {
    ;

    this.modalSearch = this.modalService.show(template1, Object.assign({}, { class: 'gray modal-lg modal-dialog-scrollable'  }, this.ngbModalOptions
    )
    );
    this.loadSearchText();
  }


  AddSearchText() {

    ;
    if (this.DuplicateNameCheck(this.utilityService.isStringNull(this.searchAdd), this.utilityService.isNumericNull(this.model.id))) {

      this.toastr.ErrorCustomMessage('Duplicates not allowed');
      return false;
    }
    if (this.searchAdd.trim() == '') {
      this.toastr.ErrorCustomMessage('Please enter required values');
      return false;
    }
    let obj = new momDashboard();
    obj.actionType = this.pagetype;
    obj.searchText = this.utilityService.isStringNull(this.searchAdd);
    obj.userUno = this.login_UserID;


    this.momMasterservice.addSearchText(obj)
      .subscribe((data) => {
        this.searchAdd = '';
        if (data != '' && data != null) {
          this.toastr.SaveMessage();
          this.loadSearchText();

        }
        else {
          this.toastr.ErrorMessage();
        }

        //this.spinner.hide();
      },
        () => {
          //Called when error
          this.toastr.ErrorMessage();
          // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }

  DuplicateNameCheck(searchText: string, searchUno: number) {
    var rtnValue = false;
    if (this.data != null && this.data != undefined) {

      this.data.forEach((grdData) => {
        //  if (roles.some(role => role.includes(extLink.role))) {
        //    extLink.visible = true;
        //  }
        if (grdData.searchText.toLocaleLowerCase() == searchText.toLocaleLowerCase() && searchUno != grdData.id) {
          rtnValue = true;
        }
      });


    }
    return rtnValue;
  }
  loadSearchText() {
    // Notiflix.Block.Dots('.pageloadcontainer');
    this.isLoader = true;
    let inpValue = new momDashboard();
    inpValue.userUno = this.login_UserID;

    this.momMasterservice.getSearchText(inpValue)
      .subscribe(data => {
        this.isLoader = false;
        this.data = data;
        
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      },
        (error) => {
          //Called when error
          this.isLoader = false;
          //Notiflix.Block.Remove('.pageloadcontainer', 800);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.isLoader = false;
        //Notiflix.Block.Remove('.pageloadcontainer', 800);
      });
  }

  searchTextFilter(data: any) {
    this.checkBoxVal = data.actionType == "ATTENDANCE" ? 2 : 1;
    this.searchText = data.searchText;
    this.getSearchList(true);
    this.modalSearch.hide();
  }
}
